export const GET_NC_ROAM_SUBSCRIPTION_PLANS_START = 'GET_NC_ROAM_SUBSCRIPTION_PLANS_START';
export const GET_NC_ROAM_SUBSCRIPTION_PLANS_SUCCESS = 'GET_NC_ROAM_SUBSCRIPTION_PLANS_SUCCESS';
export const GET_NC_ROAM_SUBSCRIPTION_PLANS_FAIL = 'GET_NC_ROAM_SUBSCRIPTION_PLANS_FAIL';

export const GET_NC_ROAM_AGENCY_SUBSCRIPTION_START = 'GET_NC_ROAM_AGENCY_SUBSCRIPTION_START';
export const GET_NC_ROAM_AGENCY_SUBSCRIPTION_SUCCESS = 'GET_NC_ROAM_AGENCY_SUBSCRIPTION_SUCCESS';
export const GET_NC_ROAM_AGENCY_SUBSCRIPTION_FAIL = 'GET_NC_ROAM_AGENCY_SUBSCRIPTION_FAIL';

export const GET_NC_ROAM_USERS_START = 'GET_NC_ROAM_USERS_START';
export const GET_NC_ROAM_USERS_SUCCESS = 'GET_NC_ROAM_USERS_SUCCESS';
export const GET_NC_ROAM_USERS_FAIL = 'GET_NC_ROAM_USERS_FAIL';

export const NC_ROAM_SUBSCRIBE_START = 'NC_ROAM_SUBSCRIBE_START';
export const NC_ROAM_SUBSCRIBE_SUCCESS = 'NC_ROAM_SUBSCRIBE_SUCCESS';
export const NC_ROAM_SUBSCRIBE_FAIL = 'NC_ROAM_SUBSCRIBE_FAIL';

export const NC_ROAM_CANCEL_SUBSCRIPTION_START = 'NC_ROAM_CANCEL_SUBSCRIPTION_START';
export const NC_ROAM_CANCEL_SUBSCRIPTION_SUCCESS = 'NC_ROAM_CANCEL_SUBSCRIPTION_SUCCESS';
export const NC_ROAM_CANCEL_SUBSCRIPTION_FAIL = 'NC_ROAM_CANCEL_SUBSCRIPTION_FAIL';

export const NC_ROAM_UPGRADE_SUBSCRIPTION_START = 'NC_ROAM_UPGRADE_SUBSCRIPTION_START';
export const NC_ROAM_UPGRADE_SUBSCRIPTION_SUCCESS = 'NC_ROAM_UPGRADE_SUBSCRIPTION_SUCCESS';
export const NC_ROAM_UPGRADE_SUBSCRIPTION_FAIL = 'NC_ROAM_UPGRADE_SUBSCRIPTION_FAIL';
